import * as tslib_1 from "tslib";
import { TabType } from '../store/schema/TabViewState';
import { getStore } from '../store/tabStore';
export default function findTabByData(data) {
    var e_1, _a;
    var store = getStore();
    try {
        for (var _b = tslib_1.__values(store.tabs), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tab = _c.value;
            if (tab.type !== TabType.Primary && tab.data == data) {
                return tab;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
//# sourceMappingURL=findTabByData.js.map